import Layout from '@/layout'

const hospitalManage = {
    path: '/content',
    component: Layout,
    children: [
        {
            path: 'expertSeminar',
            component: () => import('@/views/doctor/content/expertSeminar')
        },
        {
            path: 'expertSeminar/add',
            name: 'expertSeminarAdd',
            component: () => import('@/views/doctor/content/expertSeminarAdd'),
            meta: { activeMenu: '/content/expertSeminar' }
        },
        {
            path: 'expertSeminar/edit',
            name: 'expertSeminarEdit',
            component: () => import('@/views/doctor/content/expertSeminarEdit'),
            meta: { activeMenu: '/content/expertSeminar' }
        },
        {
            path: 'videoLibrary',
            name: 'videoLibraryList',
            component: () => import('@/views/doctor/content/videoLibrary')
        },
        {
            path: 'videoSet',
            name: 'videoSet',
            component: () => import('@/views/doctor/content/videoSet')
        },
        {
            path: 'videoSet/edit',
            name: 'editVideoSet',
            component: () => import('@/views/doctor/content/editVideoSet'),
            meta: { activeMenu: '/content/videoSet' }
        },
        {
            path: 'videoSet/edit/addVideo',
            name: 'addVideo',
            component: () => import('@/views/doctor/content/addVideoInVideoSet'),
            meta: { activeMenu: '/content/videoSet' }
        }
    ]
}

export default hospitalManage
